<!--
 * @Author: peng.chen2
 * @Date: 2022-07-11 12:27:08
 * @LastEditors: peng.chen2
 * @LastEditTime: 2023-01-30 19:09:52
 * @Description: 
 * 
 * Copyright (c) 2023 by feiniu/${git_name}, All Rights Reserved. 
-->
<template>
  <el-container class="fater-app">
    <el-header class="father-header">
      <div>peng.个人资源整理</div>
    </el-header>
    <el-main >
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<style>
html, body{
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
<style lang="less" scoped>
.fater-app{
  height: 100%;
}
.father-header{
  font-size: 20px;
  border-bottom: 1px solid #eaecef;
  box-sizing: border-box;
  line-height: 60px;
}
.container{
  height: calc(100vh - 68px);
  overflow: hidden;
}
</style>

